<div formGroupName="registContractInfoForm">

  <h2>包括お客さま情報</h2>
  <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
    <mat-form-field *ngIf="houkatsuOkyakusamaNoDispFlg" appearance="fill"
      class="input-form-select tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
      <mat-label>包括お客さま番号</mat-label>
      <input matInput readonly="true" formControlName="houkatsuOkyakusamaNo" class="font-color-display-only" />
    </mat-form-field>

    <mat-form-field appearance="outline"
      class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
      <mat-label>包括お客さま名</mat-label>
      <input matInput formControlName="houkatsuOkyakusamaName" autocomplete="off" maxlength="50" required />
    </mat-form-field>
  </div>

  <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
    <mat-form-field appearance=outline
      class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[20%]">
      <mat-label>郵便番号</mat-label>
      <input matInput #yubinInput formControlName="yubinNo" (input)="formatYubinNo()" autocomplete="off" maxlength="8"
        required />
    </mat-form-field>

    <div fxLayoutAlign="center center"
      class="tw-flex tw-flex-row tw-flex-wrap tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-[140px] tw-max-w-[140px] tw-min-w-[140px]">
      <button mat-raised-button type="button" id="zyuushoSearch"
        class="btnZyuushoSearch tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-[100px] tw-max-w-[100px] tw-min-w-[100px]"
        (click)="onClickZyuushoSearch(yubinInput.value, null)" color="primary" [disabled]="zyuushoSearchDisabledFlg">
        検索
      </button>
    </div>
  </div>

  <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
    <mat-form-field appearance="outline"
      class="input-form-select tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[20%]">
      <mat-label>都道府県</mat-label>
      <input matInput readonly="true" formControlName="todoufuken" required />
      <input type="hidden" formControlName="todoufukenCategory" autocomplete="off" />
    </mat-form-field>

    <mat-form-field appearance="outline"
      class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[20%]">
      <mat-label>行政市区</mat-label>
      <input matInput readonly="true" formControlName="gyouseishiku" required />
      <input type="hidden" formControlName="gyouseishikuCategory" autocomplete="off" />
    </mat-form-field>

    <mat-form-field appearance="outline"
      class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[20%]">
      <mat-label>行政町名</mat-label>
      <input matInput readonly="true" formControlName="gyouseichomei" required />
      <input type="hidden" formControlName="gyouseichomeiCategory" autocomplete="off" />
    </mat-form-field>
  </div>

  <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
    <mat-form-field appearance="outline"
      class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[20%]">
      <mat-label>丁目</mat-label>
      <mat-select formControlName="chomeCategory" required>
        <mat-option *ngFor="let chome of chomeList" [value]="chome.value">
          {{chome.viewValue}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance=outline
      class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[20%]">
      <mat-label>番地・号</mat-label>
      <input matInput formControlName="banchi" autocomplete="off" maxlength="5" />
    </mat-form-field>

    <mat-form-field appearance=outline
      class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[20%]">
      <mat-label>建物名</mat-label>
      <input matInput formControlName="tatemonoName" autocomplete="off" maxlength="36" />
    </mat-form-field>

    <mat-form-field appearance=outline
      class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[20%]">
      <mat-label>部屋番号</mat-label>
      <input matInput formControlName="heyaNo" autocomplete="off" maxlength="30" />
    </mat-form-field>
  </div>

  <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
    <mat-form-field appearance="outline"
      class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
      <mat-label>契約担当部署</mat-label>
      <mat-select formControlName="keiyakuTantouBushoCategory" (selectionChange)="onChangeSelectBox($event)">
        <mat-option *ngFor="let keiyakuTantouBusho of keiyakuTantouBushoList" [value]="keiyakuTantouBusho.value">
          {{keiyakuTantouBusho.viewValue}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="keiyakuTantouflg" appearance="outline"
      class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
      <mat-label>契約担当者</mat-label>
      <mat-select formControlName="keiyakuTantoushaCategory" (selectionChange)="onChangeTantousha($event)" required>
        <mat-option *ngFor="let keiyakuTantousha of keiyakuTantoushaList" [value]="keiyakuTantousha.value">
          {{keiyakuTantousha.viewValue}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="!keiyakuTantouflg" appearance="outline"
      class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
      <mat-label>契約担当者</mat-label>
      <input matInput formControlName="keiyakuTantousha" autocomplete="off" maxlength="50" required />
    </mat-form-field>
  </div>

  <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
    <mat-form-field appearance="outline"
      class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
      <mat-label>包括お客さま担当部署</mat-label>
      <input matInput formControlName="houkatsuOkyakusamaTantoBusho" autocomplete="off" maxlength="50" />
    </mat-form-field>

    <mat-form-field appearance="outline"
      class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
      <mat-label>包括お客さま担当者</mat-label>
      <input matInput formControlName="houkatsuOkyakusamaTantosha" autocomplete="off" maxlength="50" />
    </mat-form-field>

    <mat-form-field appearance="outline"
      class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
      <mat-label>包括お客さま電話番号</mat-label>
      <input matInput formControlName="houkatsuOkyakusamaTELNo" autocomplete="off" maxlength="13" />
    </mat-form-field>
  </div>

  <h2>包括契約情報</h2>
  <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
    <mat-form-field appearance="outline"
      class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[20%]">
      <mat-label>契約開始日</mat-label>
      <input matInput [matDatepicker]="keiyakuKaishiYMD" formControlName="keiyakuKaishiYMD" autocomplete="off"
        maxlength="10" required />
      <mat-datepicker-toggle matSuffix [for]="keiyakuKaishiYMD"></mat-datepicker-toggle>
      <mat-datepicker #keiyakuKaishiYMD></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline"
      class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[20%]">
      <mat-label>包括契約適用年数</mat-label>
      <input matInput formControlName="houkatsuTekiyouNensu" autocomplete="off" maxlength="3" required />
    </mat-form-field>

    <mat-form-field appearance="outline"
      class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[20%]">
      <mat-label>契約変更適用開始日</mat-label>
      <input matInput [matDatepicker]="keiyakuHenkouTekiyouKaishiYMD" formControlName="keiyakuHenkouTekiyouKaishiYMD"
        autocomplete="off" maxlength="10" required />
      <mat-datepicker-toggle matSuffix [for]="keiyakuHenkouTekiyouKaishiYMD"></mat-datepicker-toggle>
      <mat-datepicker #keiyakuHenkouTekiyouKaishiYMD></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline"
      class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[20%]">
      <mat-label>契約満了日</mat-label>
      <input matInput [matDatepicker]="keiyakuManryouYMD" formControlName="keiyakuManryouYMD" autocomplete="off"
        maxlength="10" required />
      <mat-datepicker-toggle matSuffix [for]="keiyakuManryouYMD"></mat-datepicker-toggle>
      <mat-datepicker #keiyakuManryouYMD></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline"
      class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[20%]">
      <mat-label>解約日</mat-label>
      <input matInput [matDatepicker]="kaiyakuYMD" formControlName="kaiyakuYMD" autocomplete="off" maxlength="10" />
      <mat-datepicker-toggle matSuffix [for]="kaiyakuYMD"></mat-datepicker-toggle>
      <mat-datepicker #kaiyakuYMD></mat-datepicker>
    </mat-form-field>
  </div>

  <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
    <mat-form-field appearance="outline"
      class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[25%]">
      <mat-label>割引・割増種類</mat-label>
      <mat-select formControlName="houkatsuHouhouCategory" (selectionChange)="changedCategory($event.value)" required>
        <mat-option *ngFor="let houkatsuHouhou of houkatsuHouhouList"
          [value]="houkatsuHouhou.value">{{houkatsuHouhou.viewValue}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
    <mat-form-field appearance="outline"
      class="input-form-select tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[100%]">
      <mat-label>メモ</mat-label>
      <textarea matInput rows="2" formControlName="memo" class="textarea-style" autocomplete="off"
        maxlength="1500"></textarea>
    </mat-form-field>
  </div>
</div>